// Polygon style constants
export const DEFAULT_POLYGON_STYLE = {
  color: '#ffffff',
  opacity: 0.7,
  blinkEnabled: true,
  blinkSpeed: 2500,
};

// Color preset options
export const COLOR_PRESETS = [
  { name: 'Green', color: '#00ff88' },
  { name: 'Red', color: '#ff4444' },
  { name: 'Blue', color: '#4488ff' },
  { name: 'Yellow', color: '#ffdd00' },
  { name: 'Pink', color: '#ff44aa' },
  { name: 'Cyan', color: '#00ffff' },
  { name: 'White', color: '#ffffff' },
  { name: 'Orange', color: '#ff8800' },
];

// Blink speed options
export const BLINK_SPEEDS = [
  { name: 'Very Fast', value: 200 },
  { name: 'Fast', value: 400 },
  { name: 'Normal', value: 800 },
  { name: 'Slow', value: 1500 },
  { name: 'Very Slow', value: 2500 },
];

// Default polygons (can be loaded on startup)
export const DEFAULT_POLYGONS = [];
